import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { SxProps, Theme, Typography } from '@mui/material';

const customStyles: Record<string, SxProps<Theme>> = {
  notice: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#D8EFFE',
    borderWidth: '1px 1px 1px 5px',
    borderColor: '#8BC6FD',
    borderStyle: 'solid',
    borderRadius: '12px',
    padding: '8px',
    '& svg': {
      color: '#3E8FFA',
      marginRight: '9px',
      marginLeft: '9px',
    },
  },
};

interface InfoAlertProps {
  message: string | JSX.Element;
}

export const InfoAlert = ({ message }: InfoAlertProps) => {
  return (
    <Typography sx={customStyles.notice}>
      <ErrorOutlineIcon fontSize='small' />
      {message}
    </Typography>
  );
};
